import { createContext } from 'react'

export default createContext({ zipCode: '', setZipCode: () => {} })
